module.exports = __webpack_public_path__ + "34df505128891a05e0ab23058c5c2c64.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/helm-s.png
// module id = 1905
// module chunks = 0